/** Dual-session helpers — admin and user can stay logged in together. */

const USER_KEYS = ["token", "uid", "user", "apiKey", "instanceLimit"];
const ADMIN_KEYS = ["adminToken", "admin", "adminUid"];

export function syncRoleHint() {
  const hasAdmin = !!localStorage.getItem("adminToken");
  const hasUser = !!localStorage.getItem("token");
  if (hasAdmin && hasUser) localStorage.setItem("role", "both");
  else if (hasAdmin) localStorage.setItem("role", "admin");
  else if (hasUser) localStorage.setItem("role", "user");
  else localStorage.removeItem("role");
}

/** One-time migrate from single shared `token` + `role` storage. */
export function migrateLegacySessions() {
  try {
    const role = localStorage.getItem("role");
    const token = localStorage.getItem("token");
    const adminToken = localStorage.getItem("adminToken");

    if (role === "admin" && token && !adminToken) {
      localStorage.setItem("adminToken", token);
      if (!localStorage.getItem("admin")) {
        localStorage.setItem(
          "admin",
          JSON.stringify({
            uid: localStorage.getItem("uid"),
            email: null,
            role: "admin",
          })
        );
      }
      if (localStorage.getItem("uid")) {
        localStorage.setItem("adminUid", localStorage.getItem("uid"));
      }
      // Old admin session reused the user token key — free it for real users
      USER_KEYS.forEach((k) => localStorage.removeItem(k));
    }
    syncRoleHint();
  } catch {
    /* ignore */
  }
}

export function getAuthToken(role = "user") {
  return role === "admin"
    ? localStorage.getItem("adminToken")
    : localStorage.getItem("token");
}

export function hasUserSession() {
  return !!localStorage.getItem("token");
}

export function hasAdminSession() {
  return !!localStorage.getItem("adminToken");
}

export function setUserSession({ token, uid, user, apiKey, instanceLimit }) {
  if (token) localStorage.setItem("token", token);
  if (uid != null) localStorage.setItem("uid", uid);
  if (user) localStorage.setItem("user", JSON.stringify(user));
  if (apiKey != null) localStorage.setItem("apiKey", apiKey);
  if (instanceLimit != null) localStorage.setItem("instanceLimit", String(instanceLimit));
  syncRoleHint();
}

export function setAdminSession({ token, uid, admin }) {
  if (token) localStorage.setItem("adminToken", token);
  if (uid != null) localStorage.setItem("adminUid", uid);
  if (admin) localStorage.setItem("admin", JSON.stringify(admin));
  syncRoleHint();
}

export function clearUserSession() {
  USER_KEYS.forEach((k) => localStorage.removeItem(k));
  syncRoleHint();
}

export function clearAdminSession() {
  ADMIN_KEYS.forEach((k) => localStorage.removeItem(k));
  syncRoleHint();
}
